import React from "react";
import Header from "../common/Header";
import Body from "../layout/Body";
import Footer from "../common/Footer";

const Layout = () => {
  return (
    <div>
      <Header />
      <Body />
      <Footer />
    </div>
  );
};

export default Layout;
